import { createAsyncThunk } from '@reduxjs/toolkit';
import equipmentApi from '~/apis/equipment';

import { CREATE_EQUIPMENT, EDIT_EQUIPMENT, GET_EQUIPMENT, GET_EQUIPMENTS } from '~/utils/constants/actionType';
import { IEquipment, IParamsGetEquipment, IResponseGetEquipment } from '~/utils/interface/equipment';

export const handleCreateEquipment = createAsyncThunk<IEquipment, IEquipment>(
  CREATE_EQUIPMENT,
  async (data: IEquipment, { rejectWithValue }) => {
    try {
      const res = await equipmentApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetEquipments = createAsyncThunk<IResponseGetEquipment, IParamsGetEquipment>(
  GET_EQUIPMENTS,
  async (params: IParamsGetEquipment = {}, { rejectWithValue }) => {
    try {
      const res = await equipmentApi.getList(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetEquipment = createAsyncThunk<IEquipment, string>(
  GET_EQUIPMENT,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await equipmentApi.getDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleEditEquipment = createAsyncThunk<IEquipment, { id: string; params: IEquipment }>(
  EDIT_EQUIPMENT,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await equipmentApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
